export default __webpack_public_path__ + "static/media/about-section-03.e144bb09.png";